import { memoryStore } from "../../../lib/store";

/**
 * Imperative bridge to the Discovery feed's scroll container.
 *
 * The bottom Navbar lives in a sibling subtree (it's rendered as the page
 * footer), so tapping the Discovery tab while already on `/discovery` can't
 * reach the feed's scroll ref directly. The Discovery page registers its
 * scroll element here on mount; the Navbar drives it back to the top on tap.
 */
const discoveryScrollContainerStore = memoryStore<HTMLDivElement | null>(null);

export function registerDiscoveryScrollContainer(
  element: HTMLDivElement | null
): void {
  discoveryScrollContainerStore.set(element);
}

export function scrollDiscoveryToTop(): void {
  const container = discoveryScrollContainerStore.get();
  if (container === null) return;
  container.scrollTo({ top: 0, behavior: "smooth" });
}
